import React from 'react';
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import FxView from '../../../components/FxView/fxview'
import Dosier from '../../../components/RioGrande/Dosier/dosier'



const EscuelaDeFormacion = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />
      <Dosier />

      <Footer />
      <></>
    </div>
  )
}

export default EscuelaDeFormacion
